import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { FlowsDisplayGridRowDataFragmentGql } from './FlowsDisplayGridRowDataFragmentGql';

export const UpstreamFlowsFilteredByFieldQueryGql: DocumentNode = gql`
query UpstreamFlowsFilteredByFieldQuery($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowDataFragment
        }
      }
    }
  }
}
${FlowsDisplayGridRowDataFragmentGql}
`;
